import { FC, memo } from 'react';
import APP_CONFIG from '@lib/constants/APP_CONFIG';
import Link from 'next/link';

const { EMAIL_CONTACT } = APP_CONFIG;

const TermOfUseV: FC = () => {
    return (
        <>
            <div className="container px-4 md:px-35px mx-auto pt-10 pb-4 mb-10 border border-t-0">
                <div className="container mx-auto">
                    <div className="border-rouded">
                        <h1 className="font-bold text-2xl md:text-3xl mb-4 text-green-cyprus">
                            Terms of Service
                        </h1>

                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">1.</span>
                                Introduction
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        1.1.
                                    </span>
                                    These Terms of Service govern your use
                                    of&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    . By accessing, registering, or using any
                                    part of&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    , you are legally bound by these terms.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        1.2.
                                    </span>
                                    We reserve the right to modify these terms
                                    without notice. Regularly review these terms
                                    to stay informed of updates.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">2.</span>
                                User Obligations
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        2.1.
                                    </span>
                                    You agree to abide by these terms, and all
                                    local, state, national, and international
                                    laws and regulations when using our
                                    platform.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        2.2.
                                    </span>
                                    Users must be at least 16 years old. You
                                    represent and warrant that you possess the
                                    legal right and capacity to accept these
                                    Terms of Service in your jurisdiction.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">3.</span>
                                Services and Risks
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        3.1.
                                    </span>
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    &nbsp;offers promotional services for social
                                    media. While we aim to provide quality
                                    service, risks like removal or banning of
                                    your accounts exist.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        3.2.
                                    </span>
                                    You acknowledge that using our services may
                                    contravene the terms of certain third-party
                                    platforms. We bear no responsibility for any
                                    repercussions arising from such violations.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        3.3.
                                    </span>
                                    Any decision to use our services is made at
                                    your own discretion and risk.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">4.</span>
                                Account/Channel Removal
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        4.1.
                                    </span>
                                    We are not responsible for the suspension,
                                    removal, or banning of accounts or channels
                                    on any platform. Such events can occur
                                    without prior notice. Using promotional
                                    services, like those provided by&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    , may be in violation of the Terms of
                                    Service of various social media and digital
                                    platforms. If an account or channel is
                                    removed or banned, we do not offer refunds.
                                    However, if you reinstate your account or
                                    channel or create a new one, notify us with
                                    the updated details, and we&apos;ll continue
                                    to provide our services from where we
                                    paused.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        4.2.
                                    </span>
                                    Risks for Customers: Engaging with our
                                    service may be against the guidelines of
                                    certain platforms, leading to the suspension
                                    or removal of accounts and channels. Please
                                    note that if your account or channel faces
                                    any penalties, you assume all associated
                                    consequences without any financial or other
                                    compensation from us.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">5.</span>
                                Purchases
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        5.1.
                                    </span>
                                    Understand the specifics of the product or
                                    service before purchasing.&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    &nbsp;will not entertain fraudulent disputes
                                    against any payment channels.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        5.2.
                                    </span>
                                    Transferring balances or credits between
                                    services or accounts on&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    &nbsp; is strictly prohibited.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">6.</span>
                                Limitation of Liability & Disclaimer
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        6.1.
                                    </span>
                                    Neither&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    &nbsp;nor its affiliates shall be liable for
                                    any direct, indirect, incidental, punitive,
                                    or consequential damages resulting from your
                                    use or inability to use our services.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        6.2.
                                    </span>
                                    Our services are offered without warranties
                                    of any kind, either express or implied.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">7.</span>
                                Indemnification
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        7.1.
                                    </span>
                                    You will indemnify and hold&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    , its subsidiaries, affiliates, licensors,
                                    content providers, service providers,
                                    employees, agents, officers, directors, and
                                    contractors (the &quot;Indemnified
                                    Parties&quot;) harmless from any breach of
                                    these Terms of Service by you.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">8.</span>
                                Copyright & Intellectual Property
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        8.1.
                                    </span>
                                    All content, including texts, graphics,
                                    logos, and software used on this site, is
                                    the property of&nbsp;
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    &nbsp;or its content suppliers and protected
                                    by international copyright laws.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        8.2.
                                    </span>
                                    You are prohibited from modifying, copying,
                                    distributing, transmitting, displaying,
                                    publishing, selling, licensing, or using any
                                    content available on or through the site for
                                    commercial or public purposes.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">9.</span>
                                Termination
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        9.1.
                                    </span>
                                    <Link href="/">
                                        <a>Viewpals.co</a>
                                    </Link>
                                    &nbsp;reserves the right, in its sole
                                    discretion, to terminate your access to all
                                    or part of the Site, with or without notice,
                                    for any reason, including, without
                                    limitation, breach of these Terms of
                                    Service.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">10.</span>
                                Governing Law
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        10.1.
                                    </span>
                                    All matters relating to your access to, or
                                    use of, this Site shall be governed by the
                                    laws of the Kingdom of Thailand
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">11.</span>
                                Dispute Resolution
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        11.1.
                                    </span>
                                    Any disagreements or claims arising from or
                                    relating to these Terms or the Services
                                    shall be settled through binding arbitration
                                    conducted in Bangkok, Thailand, following
                                    the then-current rules of The Kingdom of
                                    Thailand.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">12.</span>
                                Miscellaneous
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        12.1.
                                    </span>
                                    The invalidity or unenforceability of any
                                    provisions of these Terms will not affect
                                    the validity or enforceability of any other
                                    provision.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        12.2.
                                    </span>
                                    No delay or failure on our part to enforce
                                    our rights or remedies under these Terms
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                <span className="inline-block w-7">13.</span>
                                Amendments
                            </h2>
                            <ul className="ml-7">
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    <span className="inline-block w-8">
                                        13.1.
                                    </span>
                                    These Terms of Service can be amended at any
                                    time. Changes are effective upon posting on
                                    the Site.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default memo<{}>(TermOfUseV);
